enum ThirdPartySyncStatus {
    /**
     * The entity was never synchronized.
     */
    NotSynchronized = 0,

    /**
     * The latest version of the entity is synchronized.
     */
    Synchronized = 1,

    /**
     * The entity has changed since its last synchronization and needs to be resynced.
     */
    ResynchronizationNeeded = 2,

    /**
     * An error occurred during last entity synchronization.
     */
    SynchronizationError = 3
}

export { ThirdPartySyncStatus };
